import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

// import settings from "./configs/fady.config";

// dynamic imports don't like template strings
import(process.env.CONFIG_FILE).then(
  ({ controlsSettings, cameraSettings, models, text }) => {
    ReactDOM.render(
      <React.StrictMode>
        <App
          controlsSettings={controlsSettings}
          cameraSettings={cameraSettings}
          models={models}
          landingText={text}
        />
      </React.StrictMode>,
      document.getElementById("root")
    );
  }
);
